const MODULE = 'LOGS';

export const REDUCER_KEY = 'logsReducer';

export const LOGS = 'LOGS';
export const TERMS = 'TERMS';

export const GET_LOGS = `${MODULE}_GET_${LOGS}`;
export const GET_TERMS = `${MODULE}_GET_${TERMS}`;
